import { useState } from "react";
import { Form, Select, App } from "antd";

import { updateForm } from "@/api/requests";

const ACCESS_TYPES = {
  PUBLIC: "public",
  AUTHORIZED: "authorized",
  UNITS: "unit_restricted",
};

const ACCESS_TYPE_LABELS = {
  [ACCESS_TYPES.PUBLIC]: "Публичная",
  [ACCESS_TYPES.AUTHORIZED]: "Только для авторизованных пользователей",
  [ACCESS_TYPES.UNITS]: "Только для участников выбранных рабочих групп",
};

const AccessCard = ({ data, isDeleted, fetchData }) => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  const handleChangeAccessMode = async (access_mode) => {
    try {
      setLoading(true);

      await updateForm({
        uuid: data.uuid,
        access_mode,
      });

      message.success("Тип доступа обновлен");
      fetchData();
    } catch (error) {
      message.error(error?.message || "Не удалось обновить тип доступа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{padding: "0px 20px"}}>
      <Form.Item label="Доступ" style={{ marginBottom: 0 }}>
        <Select
          value={data?.access_mode}
          style={{ width: 400 }}
          disabled={isDeleted || loading}
          loading={loading}
          onChange={handleChangeAccessMode}
          options={[
            {
              value: ACCESS_TYPES.PUBLIC,
              label: ACCESS_TYPE_LABELS[ACCESS_TYPES.PUBLIC],
            },
            {
              value: ACCESS_TYPES.AUTHORIZED,
              label: ACCESS_TYPE_LABELS[ACCESS_TYPES.AUTHORIZED],
            },
            {
              value: ACCESS_TYPES.UNITS,
              label: ACCESS_TYPE_LABELS[ACCESS_TYPES.UNITS],
            },
          ]}
        />
      </Form.Item>
    </div>
  );
};

export default AccessCard;
